// The pixel box each of Person's imageSize steps renders at.
//
// Its own module, not an export from person.js: person.js reaches the shared util barrel, which
// reaches the task modal, which reaches back here - so a caller that read this off person.js got
// `undefined` whenever the cycle happened to resolve person.js first. Nothing else is in this file
// for that reason.
//
// Exported because a caller sometimes has to line something else up with the avatar - the Nova
// thread draws the agent's mark beside it - and the alternative is copying a number from here into
// a constant there, where nothing keeps the two in step.
export const PERSON_IMAGE_SIZES = {
	small: 16,
	medium: 24,
	'new-ui-person-dropdown': 26,
	'new-ui-dropdown': 30,
	large: 34,
	'very-large': 40,
} as const;
